import React, { useContext }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

import {
  Card,
  CardMedia,
  Popper,
  Grow,
  Paper,
  ClickAwayListener, MenuList, MenuItem, ButtonBase, Divider
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import _ from "underscore";
import {useHistory} from "react-router-dom";
import * as AccessControl from "../AccessControl";
import SystemContext from '../SystemContext';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '75vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 1000,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  card: {
    padding: 4,
    minWidth: 200,
    maxWidth: 300,
    borderRadius: 12,
    position: 'relative',
    backgroundColor: '#f8f8fa',
  },
  cardContent: {
    padding: "8px 4px 8px 4px",
    backgroundColor: '#f8f8fa',
  },
  media: {
    height: 200,
    paddingTop: '56.25%', // 16:9
  },
  cardTitle: {
    fontSize:25,
    fontWeight:800,
    fontFamily:"Ubuntu, sans-serif",
    fontVariantCaps: "small-caps",
    width: "100%", marginTop: 15, marginLeft: -30, alignContent: "center"
  },
  selected: {
    backgroundColor: "primary",
  }
}));

const TileGrid = (props) => {
  const SystemData = useContext(SystemContext);

  const classes = useStyles();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openUserMenu, setOpenUserMenu] = React.useState(false);
  const [placement, setPlacement] = React.useState();
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const anchorRef = React.useRef(null);

  const menuItems = SystemData.menuItems || [];

  const handleToggle = (newPlacement) => (event) =>{

    const menuId = _.where(menuItems, {name: event.currentTarget.ariaLabel});
    const subMenus = _.where(menuItems, {parentId: menuId[0].id});
    if (subMenus && subMenus.length === 0) {
      history.push(menuId[0].path);
      return
    }

    setAnchorEl(event.currentTarget);
    setOpenUserMenu((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);

    if (menuId && menuId.length > 0)
      setCurrentMenu({menuId: menuId[0].id})
  };

  const handleUserMenuClose = (event) => {

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    if (event.currentTarget.attributes && event.currentTarget.attributes["path"])
    {
      const path = event.currentTarget.attributes.getNamedItem("path");
      history.push(path.nodeValue);
    }

    setOpenUserMenu(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenUserMenu(false);
    }
  }

  const handleCardClick = (event) => {
    if (event.currentTarget.attributes && event.currentTarget.attributes["menuid"])
    {
      const menuId = event.currentTarget.attributes.getNamedItem("menuid");
      const subMenus = _.where(menuItems, {parentId: menuId.nodeValue});
      if (subMenus && subMenus.length > 0) {
        for (let i=0; i < subMenus.length; i++) {
          const item = subMenus[i];
          if (AccessControl.userHasAccess(props.loggedInUser, item.roles)) {
            history.push(item.path);
            break;
          }
        }
      }
      else
        history.push(menuId.nodeValue);
    }
  }

  const renderMenuItems = () => {
    return (
      menuItems.map((item) => {
        if (currentMenu && currentMenu.menuId && item.parentId === currentMenu.menuId && AccessControl.userHasAccess(props.loggedInUser, item.roles)) {
          if (item.name === "Divider") {
            return (
              <Divider key={item.id}/>
            );
          }
          return(<MenuItem onClick={handleUserMenuClose} path={item.path} key={item.name}>{item.name}</MenuItem>)
        }
        else
          return null;
      }
    ))
  }

  return (
    <div className={classes.root} >
      <Popper open={openUserMenu} anchorEl={anchorEl} placement={placement} transition disablePortal style={{ zIndex: 100 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper elevation={5}>
              <ClickAwayListener onClickAway={handleUserMenuClose}>
                <MenuList autoFocusItem={openUserMenu} id="menu-list-grow" onKeyDown={handleListKeyDown} variant={"menu"}>
                  {renderMenuItems()}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {menuItems.map((item) => {
            if (item.parentId === "" && item.name !== "Home" && AccessControl.userHasAccess(props.loggedInUser, item.roles)) {
              return (
                <Grid item xs={12} sm={6} md={3} key={item.name}>
                  <Card className={classes.card}>
                    <CardContent className={classes.cardContent}>
                      <div style={{display: "flex", marginLeft: -15}}>
                        <IconButton aria-label={item.name} color="primary" onClick={handleToggle("bottom-start")} >
                          <MoreVertIcon fontSize="large" />
                        </IconButton>
                        <div className={classes.cardTitle}>
                            {item.name}
                        </div>
                      </div>
                    </CardContent>
                    {/*<CardHeader*/}

                    {/*  action={*/}
                    {/*    <IconButton aria-label={tile.title}>*/}
                    {/*      <MoreVertIcon />*/}
                    {/*    </IconButton>*/}
                    {/*  }*/}
                    {/*  title={tile.title}*/}
                    {/*  // subheader="September 14, 2016"*/}
                    {/*/>*/}
                    <ButtonBase
                      menuid={item.id}
                      onClick={handleCardClick}
                    >
                      <CardMedia
                        component="img"
                        alt={item.name}
                        style={{height: 140, width:300}}
                        image={item.img}
                        title={item.name}
                      />
                      {/*<CardContent></CardContent>*/}
                    </ButtonBase>
                  </Card>
                </Grid>
              )
            } else return null;
          }
        )}
      </Grid>
    </div>
  );
}

export default TileGrid;
